import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colorPalette } from '@command-center-app/utils/colorPalette';

interface GenericModelImageListProps {
  files: any[];
  onRemove: (index: number) => void;
  showInModal?: boolean;
}

const GenericModelImageList: React.FC<GenericModelImageListProps> = ({ 
  files, 
  onRemove,
}) => {
  if (files.length === 0) return null;

  const isImageFile = (file: any) => {
    if (file.type) {
      return file.type.startsWith('image/');
    }
    const fileName = file.name || file.url || '';
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp'];
    return imageExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
  };

  return (
    <Box sx={{ mt: 2 }}>
      {files.map((file, index) => {
        const canPreview = isImageFile(file);
        const imageUrl = file.url || (file instanceof File ? URL.createObjectURL(file) : null);

        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: colorPalette.colorVeryLightGray,
              borderRadius: '8px',
              padding: '12px 16px',
              mb: index < files.length - 1 ? 1.5 : 0,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, minWidth: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  borderRadius: '4px',
                }}
              >
                {canPreview && imageUrl ? (
                  <img 
                    src={imageUrl} 
                    alt="preview" 
                    style={{ 
                      height: 50,
                      objectFit: 'cover',
                      borderRadius: '4px'
                    }} 
                  />
                ) : (
                  <img 
                    src="/assets/images/view-document.svg" 
                    alt="document" 
                    style={{ height: 42 }} 
                  />
                )}
              </Box>
              
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: colorPalette.colorAccent,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {file.name}
                </Typography>
                {!canPreview && (
                  <Typography
                    sx={{
                      fontSize: '12px',
                      mt: 0.5,
                    }}
                  >
                    File type can't be previewed
                  </Typography>
                )}
              </Box>
            </Box>

            <IconButton
              size="small"
              onClick={() => onRemove(index)}
            >
              <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Box>
        );
      })}
    </Box>
  );
};

export default GenericModelImageList;